import React from 'react'
import { Redirect } from 'react-router-dom'
import ProtectBySession from '../components/Security/ProtectBySession'
import routes from '../config/settings/routes'

/**
 * The Home' page.
 */
const Home = () => {
  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)} redirectTo={routes.login}>
      <Redirect to={routes.root} />
    </ProtectBySession>
  )
}

export default Home
